import React from 'react';

const KristofferCarlssonTilesOnly1 = () => {
  return (
    <div>
      <a className="KristofferCarlsson-navbar-brand" href="https://kristofferc.github.io/">Kristoffer Carlsson</a>

      <div className="KristofferCarlsson-article-list-item" style={{ margin: 0 }}>
        <h3 className="KristofferCarlsson-article-title" style={{ margin: 0 }}>
          <a href="http://kristofferc.github.io/post/intrinsics/">SIMD and SIMD-intrinsics in Julia</a> <span className="KristofferCarlsson-article-date">
            <time>Tue, Nov 13, 2018</time>
          </span>
        </h3>

        {/* <div className="KristofferCarlsson-article-metadata">
          

          <span className="KristofferCarlsson-article-tags">
            <i className="fa fa-tags"></i>
            <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/simd">simd</a>,
            <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/intrinsics">intrinsics</a>,
            <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/julia">julia</a>
          </span>
        </div>

        <div className="KristofferCarlsson-article-style" style={{ margin: 0 }}>
          <p>Short guide on SIMD and how to call (SIMD) intrinsics in the Julia programming language.</p>
        </div> */}
      </div>

      <div className="KristofferCarlsson-article-list-item" style={{ margin: 0 }}>
        <h3 className="KristofferCarlsson-article-title" style={{ margin: 0 }}>
          <a href="http://kristofferc.github.io/post/vectorization_performance_study/">Case study: Improving performance of a code written in Matlab style</a>   <span className="KristofferCarlsson-article-date">
            <time>Mon, Dec 26, 2016</time>
          </span>
        </h3>

        {/* <div className="KristofferCarlsson-article-metadata">
        

          <span className="KristofferCarlsson-article-tags">
            <i className="fa fa-tags"></i>
            <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/performance">performance</a>,
            <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/vectorization">vectorization</a>,
            <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/loops">loops</a>,
            <a className="KristofferCarlsson-article-tag-link" href="http://kristofferc.github.iotags/julia">julia</a>
          </span>
        </div>

        <div className="KristofferCarlsson-article-style">
          <p>Analysis and optimization of a small code snippet posted on the Julia discourse mailing list.</p>
        </div>*/}
      </div> 
    </div>
  );
};

export default KristofferCarlssonTilesOnly1;
